module.exports = {
  siteTitle: 'Δρ. Ζαχαρίας Καλαϊτζάκης MD, PhD Βαρίατρος – Διδάκτωρ Γαστρεντερολογίας & Διατροφής - Ιατρική Σχολή Πανεπιστημίου Κρήτης - Επιστημονικός Διευθυντής ΒΜΙ',
  manifestName: 'Bariatriki',
  manifestShortName: 'Bariatriki',
  manifestStartUrl: 'https://www.bariatriki.com',
  manifestBackgroundColor: '#663399',
  manifestThemeColor: '#663399',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/img/website-icon.png',
  pathPrefix: `/`,
  heading: 'Το Bariatriki.gr σύντομα κοντά σας!',
  subHeading1: "Κάνε τη σωστή κίνηση στην Υγεία σου...",
  subHeading2: "Θεράπευσε το Βάρος με τη Μεσογειακή Διατροφή!",
  socialLinks: [
    {
      icon: 'fa-brands fa-instagram',
      name: 'Instagram',
      url: 'https://instagram.com/drzak_bmi',
    },
    {
      icon: 'fa-brands fa-tiktok',
      name: 'TikTok',
      url: 'https://www.tiktok.com/@drzak_bmi',
    },
    {
      icon: 'fa-solid fa-envelope',
      name: 'Email',
      url: 'mailto:drkalaitzakis@yahoo.co.uk',
    },
    {
      icon: 'fa-solid fa-mobile-screen',
      name: 'Call on mobile',
      url: 'tel:+306947773003',
    },
    {
      icon: 'fa-solid fa-phone',
      name: 'Call on phone',
      url: 'tel:+302810540140',
    },
  ],
};
